import mapboxgl from 'mapbox-gl';
import * as m from "./mapInit";
import * as ch from "./contentHelper";
import * as p from "./popup";
import $ from "jquery";

//--------------------------------------------------------------
//EDUCATION
let headline = 'Education &<br/>Digital Development';
let addClassName = 'education';

let mapLayerNames = [
  'nuts3-education-1',
  'nuts3-education-2',
  'nuts3-education-3'
];
//add layers to toggleAbleLayers in mapInit
mapLayerNames.forEach(function(layerName){m.addToggleableLayer(layerName);});

let properties = [
  [
    'education-1',
    'education-2-internet-access',
    'education-3-internet-daily'
  ],

  [
    'education-2-internet-access',
    'education-1',
    'education-3-internet-daily'
  ],

  [
    'education-3-internet-daily',
    'education-1',
    'education-2-internet-access'
  ]
];

let valueNames = [
  [
  'Share of population with tertiary education [in %], 2017',
  'Households with internet access <br/>[as a share of total households], 2017',
  'Individuals who used the internet daily [in %], 2017'
  ],

  [
  'Households with internet access <br/>[as a share of total households], 2017',
  'Share of population with tertiary education [in %], 2017',
  'Individuals who used the internet daily [in %], 2017'
  ],

  [
  'Individuals who used the internet daily [in %], 2017',
  'Share of population with tertiary education [in %], 2017',
  'Households with internet access <br/>[as a share of total households], 2017'
  ]
];

let valueDescriptions = [
  [
  '',
  '',
  ''
  ],

  [
  '',
  '',
  ''
  ],

  [
  '',
  '',
  ''
  ]
];

let infoBox = [
  [ 'Code: edat_lfse_04',
    'Code: isoc_r_iacc_h',
    'Code: isoc_r_iuse_i'
  ],

  ['Code: isoc_r_iacc_h',
   'Code: edat_lfse_04',
   'Code: isoc_r_iuse_i'
  ],

  ['Code: isoc_r_iuse_i',
   'Code: edat_lfse_04',
   'Code: isoc_r_iacc_h'
  ]
];

let addTextAfterValue = [
  ['%','%','%'],
  ['%','%','%'],
  ['%','%','%']
];


//--------------------------------------------------------------

for(let i = 0; i < properties.length; i++){
  m.map.on('click',mapLayerNames[i], function (e) {
    p.getPopup(
      e,
      addClassName,
      headline,
      properties[i],
      valueNames[i],
      valueDescriptions[i],
      infoBox[i],
      addTextAfterValue[i] );
  });
};